import * as React from 'react';
import useIsOnscreen from '@/hooks/use-is-onscreen';

function useLazyLoad(
  isLazy: boolean
): [boolean, React.RefObject<HTMLDivElement>] {
  const [isRenderingPreview, setIsRenderingPreview] =
    React.useState(!isLazy);

  const wrapperRef = React.useRef<HTMLDivElement>(null);

  const isOnscreen = useIsOnscreen(wrapperRef);

  // Enable lazy-loaded sandboxes
  React.useEffect(() => {
    if (!isLazy || isRenderingPreview) {
      return;
    }

    if (isOnscreen) {
      setIsRenderingPreview(true);
    }
  }, [isRenderingPreview, isLazy, isOnscreen]);

  return [isRenderingPreview, wrapperRef];
}

export default useLazyLoad;
